<div class="pagination">
  <div
    class="w-100 d-flex align-items-center justify-content-center flex-wrap"
  >
    <ul class="list-group list-group-horizontal py-1">
      <li class="list-group-item chevron-left me-md-5" [ngClass]="{ 'disable': 1 === currentPage }">
        <ng-template #staticPreviousPage>
          <span aria-hidden="true"></span>
        </ng-template>
        <a
          *ngIf="1 < currentPage; else staticPreviousPage"
          [routerLink]="['./']"
          [queryParamsHandling]="'merge'"
          [queryParams]="{ page: currentPage - 1 }"
          routerLinkActive="active"
          aria-hidden="true"
          ></a
        >
      </li>
      <ng-container *ngIf="currentPage - rangePages > 1">
        <li class="list-group-item">
          <a
            [routerLink]="['./']"
            [queryParamsHandling]="'merge'"
            [queryParams]="{ page: 1 }"
            routerLinkActive="active"
            >1</a
          >
        </li>
        <li class="list-group-item" *ngIf="currentPage - rangePages > 2">
          <span class="fw-medium">...</span>
        </li>
      </ng-container>
      <li
        *ngFor="let n of counterPages()"
        class="list-group-item"
        [ngClass]="{ active: n === currentPage }"
      >
        <ng-template #fixedPage>
          <span class="fw-medium">{{ n }}</span>
        </ng-template>
        <a
          *ngIf="n !== currentPage; else fixedPage"
          [routerLink]="['./']"
          [queryParamsHandling]="'merge'"
          [queryParams]="{ page: n }"
          routerLinkActive="active"
          >{{ n }}</a
        >
      </li>
      <ng-container *ngIf="currentPage + rangePages < totalPages">
        <li
          class="list-group-item"
          *ngIf="currentPage + rangePages < totalPages - 1"
        >
          <span class="fw-medium">...</span>
        </li>
        <li class="list-group-item">
          <a
            [routerLink]="['./']"
            [queryParamsHandling]="'merge'"
            [queryParams]="{ page: totalPages }"
            routerLinkActive="active"
            >{{ totalPages }}</a
          >
        </li>
      </ng-container>
      <li class="list-group-item chevron-right ms-md-5" [ngClass]="{ 'disable': totalPages === currentPage }">
        <ng-template #staticNextPage>
          <span aria-hidden="true"></span>
        </ng-template>
        <a
          *ngIf="totalPages > currentPage; else staticNextPage"
          [routerLink]="['./']"
          [queryParamsHandling]="'merge'"
          [queryParams]="{ page: currentPage + 1 }"
          routerLinkActive="active"
          aria-hidden="true"
          ></a
        >
      </li>
    </ul>
  </div>
</div>
